import React, {Fragment, useState} from 'react';
import { connect } from 'react-redux';
import { /* Route,  */Redirect } from 'react-router-dom';
import {AppBar, Container, Toolbar, IconButton, Link, Hidden, Button, Drawer, Icon, Popover, ListItem, List } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import Image from './Image'
import MainNav from './MainNav'

import { logoutAction } from "../store/actions/index";
import { useTheme } from '@material-ui/core/styles';

const Header = props => {
    const theme = useTheme();
    const {client, header, misReservas} = props
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const handleDrawerToggle = () => setMobileOpen(!mobileOpen)

    

    var sessionState = sessionStorage?.getItem('isUserLogged');
    var firstName = sessionStorage?.getItem('firstName');
    //var eraId = sessionStorage?.getItem('eraId');
    var tokenClient = props.tokenClient
    var isLogin = props.isLogin

    const loginpage = window.location.pathname.indexOf("login")!== -1?true:false
    const pathnames = window.location.pathname.split("/").filter(x => x);

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => { setAnchorEl(event.currentTarget); };

    const handleClose = () => { setAnchorEl(null); };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const isLoginB2 = misReservas && misReservas.urlB2 && misReservas.urlB2 !== "";

    const DrawerList = (props) => <MainNav sessionState={sessionState} header={header} client={client}/>

    //console.log('sessionState', sessionState)
   
    return (
       
        <Fragment>
            <AppBar position="relative" className={`site-header site-header-${client.name}`}>
                <div className="page-maxwidth">
                    <Container maxWidth="xl">
                        <Toolbar className={`site_header_toolbar`} component="nav" disableGutters>
                        <div className="navbar-brand">
                            {client.urlLogo? <Link href={client.urlLogo}><Image img={`${client.name}/logo.png`} alt={client.nameCopy} /></Link>
                            :pathnames.map((value, index) => {
                            const to = `/${pathnames.slice(0, index + 1).join("/")}`;
                                return  value === 'trenes'? <Link key={index} href={to}><Image img={`${client.name}/logo.png`} alt={client.nameCopy} /></Link>: ''; 
                            })}
                        </div>  

                        <Hidden smDown >
                            <DrawerList header={header} className="drawer-navbar" /> 
                        </Hidden>

                        <Hidden mdUp>
                            <Button onClick={handleDrawerToggle} variant="outlined" color="primary" className={`menuButton`} edge="end" ><MenuIcon /></Button>
                        </Hidden>  

                        <Hidden smUp>
                            <div className="menu-mobile">
                                <Drawer onClose={handleDrawerToggle} open={mobileOpen} variant="temporary" anchor={theme.direction === 'rtl' ? 'right' : 'left'} ModalProps={{ keepMounted: true }} >
                                    <IconButton onClick={handleDrawerToggle} className="close-menu-button"><CloseIcon /></IconButton>
                                    <DrawerList header={header} className="drawer-navbar" /> 
                                </Drawer>
                            </div>
                        </Hidden>
                        {sessionState &&
                            <div className='login-content'> <Icon className='user-icon'>account_circle</Icon> Hola <span className="name">{firstName}</span></ div> 
                        } 
                        {isLogin && (

                            (sessionState==null || sessionState===undefined) ?
                            <Redirect to={{pathname:`/${tokenClient}/trenes/login`}} />
                            :
                            !loginpage? <>
                                {isLoginB2 ? <>
                                    <Button size="small" component={Link} target="_blank" variant="contained" color="secondary" className="buttonMisReservas"
                                        endIcon={<Icon fontSize="small">expand_more</Icon>}
                                        onClick={handleClick}
                                        >
                                        Mis reservas
                                    </Button>
                                    <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleClose}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                                        transformOrigin={{  vertical: 'top', horizontal: 'center', }}
                                    >
                                        <List component="nav">
                                            <ListItem button color="secondary" component={Link} href={misReservas.urlB2} target="_blank" onClick={handleClose}>
                                                Nuevo Sistema
                                            </ListItem>
                                            <ListItem button color="secondary" component={Link} href={misReservas.url} target="_blank" onClick={handleClose}>
                                                Viejo Sistema
                                            </ListItem>
                                        </List>
                                    </Popover>
                                    </> :  
                                    <Button size="small" component={Link} target="_blank" href={misReservas.url} variant="contained" color="secondary" className="buttonMisReservas" >
                                        Mis reservas
                                    </Button>
                                }

                                <Button variant="outlined" color="primary" className='linklogout'
                                    href={`/${tokenClient}/trenes/login`}
                                    title="Cerrar sesión"
                                    style={{marginRight: 8, marginLeft: 8}}
                                    onClick={() => props.dispatchLogoutAction()}
                                    >
                                    <Icon>power_settings_new</Icon> 
                                </Button>                                
                            </> : '' ) }
                         </Toolbar>
                    </Container>  
                </div>
            </AppBar>
        </Fragment>
    )
}

const mapStateToProps = reducers => {
    return reducers.loginReducer
};


const mapDispatchToProps = dispatch => {
    return {
        dispatchLogoutAction: () =>
            dispatch(
                logoutAction(),
            ) 
    };        
}



export default connect(mapStateToProps,mapDispatchToProps)(Header)